@import '@hevoio/hevo-ui-toolkit/styles/variables';

.destinationSettingsContainer {
  display: flex;
  height: 100%;
}

.setupGuideDocs {
  width: 40%;
  flex-shrink: 0;
}

.flexible-use-sample {
  flex: 1 0 auto;
}
